import { INIT_FEATURE_FLAGS } from 'actions/Types';
import { LaunchDarklyStatuses } from 'constants/LaunchDarklyStatuses';
const { INITIALIZING, ACTIVE, FAILED } = LaunchDarklyStatuses;

export default function launchDarklyStatus(state = INITIALIZING, action) {
  if (action.type === `${INIT_FEATURE_FLAGS}`) {
    return INITIALIZING;
  }
  if (action.type === `${INIT_FEATURE_FLAGS}_SUCCESS`) {
    return ACTIVE;
  }
  if (action.type === `${INIT_FEATURE_FLAGS}_FAILURE`) {
    return FAILED;
  }

  return state;
}
